import { useQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { assertionClient } from '../client/assertionClient';

type Options = {
  enabled?: boolean;
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useNextAssertionQuery = (options: Partial<Options> = defaultOptions) => {
  const { data: { data: next } = {}, ...rest } = useQuery({
    queryKey: [cacheKeys.getNextAssertion],
    queryFn: () => assertionClient.getNextAssertion(),
    ...options,
  });

  return {
    ...rest,
    next,
  };
};
